// extracted by mini-css-extract-plugin
export default {"darkBG":"Modal_darkBG__--B6i","centered":"Modal_centered__LVxzJ"};